module.exports = __webpack_public_path__ + "img/kachel-ERSCHOEPFUNG_MINDMASEREXTREME.da93b643.png";